/*
 * Comportement des menus de l'en-tete.
 *
 * DESKTOP (souris, > 1000px)
 * - Le sous-menu s'ouvre au survol du titre.
 * - Un clic sur le titre mene directement a la categorie.
 *
 * MOBILE (menu lateral)
 * - Un appui sur le nom mene a la categorie.
 * - Un appui sur la fleche ouvre / ferme le sous-menu.
 *
 * Destination d'un titre, dans l'ordre :
 *   1. le lien du menu lui-meme (reglage "Lien du titre" du bloc mega-menu,
 *      ou URL de l'element de navigation sur mobile) ;
 *   2. a defaut, la destination du bouton principal du mega-menu correspondant
 *      (ex. "Voir toutes les fleurs" -> /collections/fleurs-cbd).
 */
(function () {
  if (window.__headerMenuInit) return;
  window.__headerMenuInit = true;

  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 300;
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1001px)');

  function isDesktopHover() {
    return mq.matches;
  }

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cleanHref(value) {
    if (!value || value === '#') return null;
    return value;
  }

  // Une entree de navigation laissee sur "#" ou sur l'accueil est consideree
  // comme non renseignee : on lui prefere la destination calculee cote desktop.
  function isPlaceholder(value) {
    return !value || value === '#' || value === '/';
  }

  /* Destination de repli : le bouton principal du panneau du mega-menu. */
  function fallbackHref(item) {
    var content = item.querySelector('[data-ref="dropdown-content"]');
    if (!content) return null;

    var cta = content.querySelector('a.button');
    if (!cta) return null;

    return cleanHref(cta.getAttribute('href'));
  }

  function itemHref(item) {
    var toggle = item.querySelector('[data-ref="dropdown-toggle"]');
    if (toggle && toggle.tagName === 'A') {
      var href = cleanHref(toggle.getAttribute('href'));
      if (href) return href;
    }
    return fallbackHref(item);
  }

  /* ------------------------------------------------------------------ */
  /* Desktop                                                             */
  /* ------------------------------------------------------------------ */

  function closeAll(list, except) {
    list.querySelectorAll('dropdown-component').forEach(function (dropdown) {
      if (dropdown !== except && typeof dropdown.close === 'function') {
        dropdown.close();
      }
    });
  }

  function bindDesktopItem(list, item) {
    var openTimer = null;
    var closeTimer = null;
    var toggle = item.querySelector('[data-ref="dropdown-toggle"]');

    function clearTimers() {
      if (openTimer) clearTimeout(openTimer);
      if (closeTimer) clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function openNow() {
      clearTimers();
      closeAll(list, item);
      if (typeof item.open === 'function') item.open();
    }

    if (toggle && toggle.tagName !== 'A' && itemHref(item)) {
      toggle.setAttribute('data-has-link', 'true');
    }

    item.addEventListener('mouseenter', function () {
      if (!isDesktopHover()) return;
      clearTimers();
      openTimer = setTimeout(openNow, OPEN_DELAY);
    });

    item.addEventListener('mouseleave', function () {
      if (!isDesktopHover()) return;
      clearTimers();
      closeTimer = setTimeout(function () {
        if (typeof item.close === 'function') item.close();
      }, CLOSE_DELAY);
    });

    /*
     * Interception en phase de capture sur le composant parent : cela empeche
     * le gestionnaire natif du dropdown (preventDefault + bascule) de
     * s'executer. Selon le navigateur la cible reelle du clic peut etre le
     * <span>, le <button> ou le conteneur lui-meme.
     */
    item.addEventListener(
      'click',
      function (event) {
        if (!isDesktopHover()) return;

        var target = event.target;
        if (!target || !target.closest) return;

        // Clic a l'interieur du panneau : comportement normal des liens.
        if (target.closest('[data-ref="dropdown-content"]')) return;

        event.stopPropagation();

        var href = itemHref(item);

        if (!href) {
          event.preventDefault();
          openNow();
          return;
        }

        var clickedToggle = target.closest('[data-ref="dropdown-toggle"]');
        if (clickedToggle && clickedToggle.tagName === 'A') return;

        event.preventDefault();

        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(href, '_blank');
        } else {
          window.location.href = href;
        }
      },
      true
    );

    item.addEventListener('focusin', function () {
      if (!isDesktopHover()) return;
      openNow();
    });

    item.addEventListener('focusout', function (event) {
      if (!isDesktopHover()) return;
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      if (typeof item.close === 'function') item.close();
    });
  }

  function setupDesktop(scope) {
    scope.querySelectorAll('.header__menu-desktop-list').forEach(function (list) {
      list.querySelectorAll('dropdown-component').forEach(function (item) {
        if (item.parentElement !== list) return;
        if (item.dataset.hoverBound === 'true') return;
        item.dataset.hoverBound = 'true';
        bindDesktopItem(list, item);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Mobile                                                              */
  /* ------------------------------------------------------------------ */

  /*
   * Le menu lateral est alimente par une navigation Shopify dont les entrees
   * de premier niveau n'ont pas toujours d'URL. On reprend alors la
   * destination deja calculee pour le meme titre cote desktop, ce qui garantit
   * que les deux menus pointent au meme endroit.
   */
  function desktopHrefByTitle() {
    var map = {};

    document.querySelectorAll('.header__menu-desktop-list > dropdown-component').forEach(function (item) {
      var label = item.querySelector('.header__menu-link-text');
      var href = itemHref(item);
      if (label && href) map[normalize(label.textContent)] = href;
    });

    document.querySelectorAll('.header__menu-desktop-list > a.header__menu-link').forEach(function (link) {
      var href = cleanHref(link.getAttribute('href'));
      if (href) map[normalize(link.textContent)] = href;
    });

    return map;
  }

  function setupDrawer(scope) {
    var navs = scope.querySelectorAll('.header__mobile-menu-nav');
    if (!navs.length) return;

    var map = desktopHrefByTitle();

    navs.forEach(function (nav) {
      nav.querySelectorAll('details > summary').forEach(function (summary) {
        if (summary.dataset.titleBound === 'true') return;
        summary.dataset.titleBound = 'true';

        var title = summary.querySelector('[data-ref="mobile-menu-title"]');
        if (!title) return;

        var own = title.tagName === 'A' ? title.getAttribute('href') : null;
        var href = isPlaceholder(own) ? map[normalize(title.textContent)] || cleanHref(own) : own;

        // Sans destination, la ligne entiere ouvre le sous-menu (comportement d'origine).
        if (!href) return;

        summary.setAttribute('data-has-link', 'true');

        if (title.tagName === 'A') {
          title.setAttribute('href', href);
        } else {
          title.setAttribute('data-href', href);
        }

        summary.addEventListener('click', function (event) {
          var target = event.target;
          if (target && target.closest && target.closest('[data-ref="mobile-menu-caret"]')) {
            // Fleche : on laisse l'accordeon s'ouvrir / se fermer.
            return;
          }

          // Nom : on empeche la bascule de l'accordeon et on navigue.
          event.preventDefault();
          window.location.href = href;
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */

  function setup(root) {
    var scope = root || document;
    setupDesktop(scope);
    setupDrawer(scope);
  }

  function init() {
    setup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialisation apres un rechargement de section dans l'editeur de theme.
  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
  document.addEventListener('shopify:block:select', function () {
    setup(document);
  });
})();
